/**
 * The RRULE substituted when a caller supplies no rule — "this happens once".
 *
 * `COUNT=1` does the work: the rule emits period 0 and nothing else, so the
 * frequency never gets a second period and is arbitrary. Do not read any
 * monthly-ness into it.
 */
export const ONE_OFF_RRULE = 'FREQ=MONTHLY;COUNT=1';
